import { useEffect } from 'react';

export const useLoadCustomerIoInApp = (enabled: boolean = true) => {
  useEffect(() => {
    if (!enabled) return undefined;

    // The Gist in-app widget renders in a cross-origin iframe (renderer.gist.build),
    // so clicks inside it (e.g. the survey's plain <a target="_blank"> link) are
    // invisible to this page and never reach Customer.io's action callbacks.
    // Losing tab focus is the only observable signal that the link was followed,
    // so it's used here to hide the widget and stop it from being clicked again.
    const hideGistFrame = () => {
      const gistFrame = document.querySelector<HTMLIFrameElement>('iframe.gist-message.gist-visible');
      if (gistFrame) gistFrame.style.display = 'none';
    };
    const dismissOnHidden = () => {
      if (!document.hidden) return;
      hideGistFrame();
    };
    document.addEventListener('visibilitychange', dismissOnHidden);

    return () => {
      document.removeEventListener('visibilitychange', dismissOnHidden);
      // The widget lives outside this page's route (injected onto document.body), so an
      // SPA navigation away from this report (e.g. to the dashboard) never unmounts it on
      // its own — hide it explicitly or it bleeds through onto whatever page comes next.
      hideGistFrame();
    };
  }, [enabled]);
};
